// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__3s1CC","description":"PatientConsentPreview_description__39OPF"};